export const supportConstants = {
  GET_TICKETS_REQUEST: 'SUPPORT/GET_TICKETS_REQUEST',
  GET_TICKETS_SUCCESS: 'SUPPORT/GET_TICKETS_SUCCESS',
  GET_TICKETS_FAILURE: 'SUPPORT/GET_TICKETS_FAILURE',

  GET_TICKET_BY_ID_REQUEST: 'SUPPORT/GET_TICKET_BY_ID_REQUEST',
  GET_TICKET_BY_ID_SUCCESS: 'SUPPORT/GET_TICKET_BY_ID_SUCCESS',
  GET_TICKET_BY_ID_FAILURE: 'SUPPORT/GET_TICKET_BY_ID_FAILURE',

  SUBMIT_CONTACT_REQUEST: 'COMMON/SUBMIT_CONTACT_REQUEST',
  SUBMIT_CONTACT_SUCCESS: 'COMMON/SUBMIT_CONTACT_SUCCESS',
  SUBMIT_CONTACT_FAILURE: 'COMMON/SUBMIT_CONTACT_FAILURE',

  UPDATE_TICKET_REQUEST: 'SUPPORT/UPDATE_TICKET_REQUEST',
  UPDATE_TICKET_SUCCESS: 'SUPPORT/UPDATE_TICKET_SUCCESS',
  UPDATE_TICKET_FAILURE: 'SUPPORT/UPDATE_TICKET_FAILURE',

  CLEAR_DATA: 'SUPPORT/CLEAR_DATA'
}
